import { Callout } from "@clipboard-health/ui-components";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { minutesToMilliseconds } from "date-fns";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { useDefinedWorker } from "../../../Worker/useDefinedWorker";
import { useGetBookingRequests } from "../../WorkerShifts/BookingRequests/api/useGetBookingRequests";
import { BookingRequestStatus } from "../../WorkerShifts/BookingRequests/types";

export function BookingRequestsCallout() {
  const worker = useDefinedWorker();
  const { data: bookingRequests, isSuccess } = useGetBookingRequests(
    {
      filter: {
        status: { eq: BookingRequestStatus.PENDING },
        "worker.id": { eq: worker.userId },
      },
    },
    {
      // The shift discovery page remains mounted when opening shifts in bottom sheets,
      // preventing automatic refetches of the query on mount. Setting a stale time ensures
      // booking requests are periodically refreshed even without unmounting.
      staleTime: minutesToMilliseconds(2),
    }
  );

  const history = useHistory();

  const pendingBookingRequests = isSuccess ? bookingRequests.data : [];
  const bookingRequestsCount = pendingBookingRequests.length;

  if (bookingRequestsCount <= 0) {
    return null;
  }

  return (
    <Callout
      title={`${bookingRequestsCount} Pending ${pluralize("Request", bookingRequestsCount)}`}
      iconType="date-clock"
      sx={(theme) => ({
        color: theme.palette.shift?.bookingRequest.text,
        backgroundColor: theme.palette.shift?.bookingRequest.background,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, {
          type: "bookingRequests",
          count: bookingRequestsCount,
        });
        history.push(`${RootPaths.APP_V2_HOME}/myShifts/bookingRequests`);
      }}
    />
  );
}
